import { render } from "./courseAnalyseCreate.vue?vue&type=template&id=b7198018&scoped=true"
import script from "./courseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./courseAnalyseCreate.vue?vue&type=script&lang=js"

import "./courseAnalyseCreate.vue?vue&type=style&index=0&id=b7198018&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7198018"]])

export default __exports__